import App from "./App.svelte";
import { initDB } from "./db";
import { initLocale } from "./utils/locale";
import { IS_DEBAG, _err } from "./utils/logger";

const app = new App({
  target: document.body,
  props: {
    name: "world",
  },
});

try {
  initLocale();
  initDB();
} catch (error) {
  _err(error);
}

if (IS_DEBAG) {
  //serviceWorkerRegistration.unregister();
} else {
  // if ('serviceWorker' in navigator) {
  // 	navigator.serviceWorker
  // 		.register('/sw.js')
  // 		.then(function () {
  // 			console.log('Service worker registered!');
  // 		})
  // 		.catch(function (err) {
  // 			console.log(err);
  // 		});
  // }
  //serviceWorkerRegistration.register();
}
export default app;
